import { toConsumableArray as _toConsumableArray } from '../../_virtual/_rollupPluginBabelHelpers.mjs';

var genId = function () {
  var count = 0;
  return function () {
    return (++count).toString();
  };
}();
var generateDefaultState = function generateDefaultState(set) {
  var updateItems = function updateItems(updater) {
    set(function (state) {
      return {
        items: updater(state.items)
      };
    });
  };
  var closeItem = function closeItem(id) {
    return updateItems(function (items) {
      return items.filter(function (item) {
        return item.id !== id;
      });
    });
  };
  return {
    items: [],
    open: function open(item) {
      var id = genId();
      updateItems(function (items) {
        return [].concat(_toConsumableArray(items), [Object.assign(Object.assign({}, item), {
          id: id
        })]);
      });
      return {
        close: function close() {
          return closeItem(id);
        },
        id: id
      };
    },
    close: closeItem,
    closeAll: function closeAll() {
      return set({
        items: []
      });
    }
  };
};

export { generateDefaultState };
